import type { OrderInfo, PageInfo } from '@@partner:types:app'
import { GQL_ID } from '@@partner:graphql/types'

import { gql, useQuery } from '@apollo/client'

export interface OrdersFilterInput {
  ids: GQL_ID[]
  phone?: string
  address?: string
  from?: number
  to?: number
  statuses: number[]
  mine?: boolean
}
export interface OrdersQuery {
  orders?: {
    edges: OrderInfo[]
    pageInfo: PageInfo
  }
}

export interface OrdersQueryVariables {
  filter?: OrdersFilterInput
  page?: number
  limit?: number
}

export const GQL_QUERY_ORDERS = gql`
  query ($page: Int!, $limit: Int!, $filter: OrdersFilterInput) {
    orders(_page: $page, _limit: $limit, filter: $filter) {
      edges {
        id
        status
        shop_id
        customer_phone
        total
        delivery_total
        address
        created_at
        takenByMe
        finalCost
        isPrepayable

        customer {
          id
          fullName
        }
      }
      pageInfo {
        page
        perPage
        lastPage
        next
      }
    }
  }
`

export const useFetchOrders = (variables: OrdersQueryVariables) =>
  useQuery<OrdersQuery, OrdersQueryVariables>(GQL_QUERY_ORDERS, {
    variables,
    fetchPolicy: 'cache-and-network'
  })
